import { render, staticRenderFns } from "./contactScore.vue?vue&type=template&id=62be8d90&scoped=true"
import script from "./contactScore.vue?vue&type=script&lang=js"
export * from "./contactScore.vue?vue&type=script&lang=js"
import style0 from "./contactScore.vue?vue&type=style&index=0&id=62be8d90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62be8d90",
  null
  
)

export default component.exports